<template>
  <div
    class="progress-wrapper"
    :class="{ shake: coinAccountChanged }"
  >
    <div
      class="nav-link clickable"
      @click="$emit('click')"
    >
      <div class="d-flex flex-nowrap align-items-center">
        <i class="fa fa-coins text-cr-red-black mr-2"></i>
        <div class="progress" v-if="percentage > 30">
          <div
            class="progress-bar bg-cr-red-black"
            :style="{width: `${percentage}%`}"
            id="coin-account-progress-bar-value"
          >
            {{ coinAccount.rate }}
          </div>
        </div>
        <div class="progress" v-else>
          <div class="progress-bar bg-cr-red-black" :style="{width: `${percentage}%`}"></div>
          <div
            class="ml-3 d-flex align-items-center"
            id="coin-account-progress-bar-value"
          >
            {{ coinAccount.rate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CoinAccountProgressBar',
  computed: {
    ...mapGetters(['org', 'user', 'coinAccountChanged']),
    percentage() {
      if (this.coinAccount.rate < 1000) {
        return ((this.coinAccount.rate / 1000) * 100);
      }
      return 100;
    },
    coinAccount() {
      if (this.user.coin_account) {
        return this.user.coin_account;
      }
      return {
        rate: 0,
      };
    },
  },
  created() {
    if (this.coinAccountChanged) {
      setTimeout(() => {
        this.$store.commit('setCoinAccountChanged', false);
      }, 1000);
    }
  },
};
</script>

<style scoped>
.progress-wrapper {
  width: 150px;
}

@media (min-width: 1200px) {
  .progress-wrapper {
    width: 200px;
  }
}

.progress {
  width: 100%;
  height: 17px;
  font-size: 11px;
}

.shake {
  animation: shake 1s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
    font-size: 30px;
  }

  20%,
  80% {
    transform: translate3d(3px, 0, 0);
    font-size: 30px;
  }

  30%,
  50%,
  70% {
    transform: translate3d(-6px, 0, 0);
    font-size: 30px;
  }

  40%,
  60% {
    transform: translate3d(6px, 0, 0);
    font-size: 30px;
  }
}
</style>
